import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  FormGroup,
  FormField,
  Dropdown,
  Input,
  Checkbox
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardAppointmentListMEHUX = (props: any) => {
    return(
      <div
        style={{padding: "15px"}}>
        <div
          id="CardAppointmentSummaryListUX-div-58"
          style={{fontSize: "1.7rem", color: "rgb(79, 79, 79)", fontWeight: "bold", marginBottom: "1.5rem", marginTop: "-0.25rem",display:props.titleName?"":"none"}}>
          {props.titleName}
        </div>
        <div
          className="ui form"
          id="CardAppointmentSummaryListUX-div-1">
          
          <FormGroup
            id="CardAppointmentListMEHUX-FormGroup-60"
            inline={true}
            style={{display: "flex", alignItems: "flex-end"}}>
            <FormField
              id="CardAppointmentListMEHUX-FormField-62"
              style={{display: "block"}}
              width={3}>
              <label
                id="CardAppointmentListMEHUX-label-70">
                {props.languageUX === "en" ? "BookingID" : "BookingID"}
              </label>
              <Input
                icon="search"
                id="CardAppointmentListMEHUX-Input-90"
                name="id"
                onChange={props.onChangeData}
                placeholder="ค้นหาด้วยหมายเลขการจอง"
                value={props.appointmentList?.filterAppointmentList?.id}>
              </Input>
            </FormField>
            <FormField
              id="CardAppointmentListMEHUX-FormField-63"
              style={{display: "block"}}
              width={3}>
              <label
                id="CardAppointmentListMEHUX-label-71">
                ชื่อ - นามสกุลผู้รับบริการ
              </label>
              <div
                id="CardAppointmentListMEHUX-div-95">
                {props.searchBoxPatient}
              </div>
            </FormField>
            <FormField
              id="CardAppointmentListMEHUX-FormField-64"
              style={{display: "block"}}
              width={2}>
              <label
                id="CardAppointmentListMEHUX-label-72">
                {props.languageUX === "en" ? "Appointment date" : "วันที่นัดหมาย"}
              </label>
              <DateTextBox
                id="CardAppointmentListMEHUX-DateTextBox-84"
                onChange={props.onChangeDate("startDate")}
                value={props.appointmentList?.filterAppointmentList?.startDate}>
              </DateTextBox>
            </FormField>
            <FormField
              id="CardAppointmentListMEHUX-FormField-65">
              <label
                id="CardAppointmentListMEHUX-label-86"
                style={{paddingBottom: "10px"}}>
                {props.languageUX === "en" ? "to" : "ถึง"}
              </label>
            </FormField>
            <FormField
              id="CardAppointmentListMEHUX-FormField-80"
              style={{display: "block"}}
              width={2}>
              <label
                id="CardAppointmentListMEHUX-label-82">
                
              </label>
              <DateTextBox
                id="CardAppointmentListMEHUX-DateTextBox-85"
                onChange={props.onChangeDate("endDate")}
                value={props.appointmentList?.filterAppointmentList?.endDate}>
              </DateTextBox>
            </FormField>
            <FormField
              id="CardAppointmentListMEHUX-FormField-81">
              <div
                id="CardAppointmentListMEHUX-div-83">
                {props.buttonSearch}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardAppointmentListMEHUX-FormGroup-61"
            inline={true}
            style={{display: "flex", alignItems: "flex-end"}}>
            <FormField
              id="CardAppointmentListMEHUX-FormField-66"
              style={{display: "block"}}
              width={3}>
              <label
                id="CardAppointmentListMEHUX-label-74">
                {props.languageUX === "en" ? "Service provider" : "ผู้ให้บริการ"}
              </label>
              <div
                id="CardAppointmentListMEHUX-div-97">
                {props.searchBoxDoctor}
              </div>
            </FormField>
            <FormField
              id="CardAppointmentListMEHUX-FormField-67"
              style={{display: "block"}}
              width={3}>
              <label
                id="CardAppointmentListMEHUX-label-75">
                {props.languageUX === "en" ? "Appointment status" : "สถานะนัดหมาย"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardAppointmentListMEHUX-Dropdown-88"
                name="appointmentStatus"
                onChange={props.onChangeData}
                options={props.appointmentStatusOptions}
                selection={true}
                value={props.appointmentList?.filterAppointmentList?.appointmentStatus}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardAppointmentListMEHUX-FormField-68"
              style={{display: "block"}}
              width={3}>
              <label
                id="CardAppointmentListMEHUX-label-76">
                {props.languageUX === "en" ? "Service status" : "สถานะรับบริการ"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardAppointmentListMEHUX-Dropdown-89"
                name="orderStatus"
                onChange={props.onChangeData}
                options={props.orderStatusOptions}
                selection={true}
                value={props.appointmentList?.filterAppointmentList?.orderStatus}>
              </Dropdown>
            </FormField>
            <FormField
              style={{display: "block"}}
              width={4}>
              <label>
                
              </label>
              <div
                style={{display: "flex", alignItems: "center", marginBottom: "10px"}}>
                
                <Checkbox
                  checked={props.appointmentList?.filterAppointmentList?.noDivisionServiceBlock}
                  label="แสดงนัดหมายที่ถูกเลื่อนแบบไม่ระบุวัน"
                  name="noDivisionServiceBlock"
                  onChange={props.onChangeData}>
                </Checkbox>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardAppointmentListMEHUX-FormGroup-92"
            inline={true}
            style={{ display: "flex", justifyContent: "flex-end"}}>
            <FormField
              id="CardAppointmentListMEHUX-FormField-93">
              <div
                id="CardAppointmentListMEHUX-div-96">
                {props.buttonAppointmentFinish}
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardAppointmentSummaryListUX-div-2">
          
          <Table
            columns={props.columnsAppoitmentList}
            data={props.appointmentListData}
            defaultPageSize={10}
            getTrProps={props.onGetPatientRow}
            minRows="10"
            pageSize={10}
            showPagination={false}
            style={{height: "50vh"}}>
          </Table>
        </div>
        <div
          id="CardAppointmentSummaryListUX-div-40"
          style={{display: "flex", justifyContent: "flex-end", padding: "5px"}}>
          {props.pagination}
        </div>
      </div>
    )
}


export default CardAppointmentListMEHUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Tue Dec 16 2025 13:06:22 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"15px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-div-1"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-div-2"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 15,
      "name": "Table",
      "parent": 2,
      "props": {
        "columns": {
          "type": "code",
          "value": "props.columnsAppoitmentList"
        },
        "data": {
          "type": "code",
          "value": "props.appointmentListData"
        },
        "defaultPageSize": {
          "type": "code",
          "value": "10"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.onGetPatientRow"
        },
        "headers": {
          "type": "value",
          "value": "",
          "valueEN": ""
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "keys": {
          "type": "value",
          "value": ""
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "pageSize": {
          "type": "code",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"50vh\"}"
        },
        "widths": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pagination"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", padding: \"5px\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.titleName"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentSummaryListUX-div-58"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.7rem\", color: \"rgb(79, 79, 79)\", fontWeight: \"bold\", marginBottom: \"1.5rem\", marginTop: \"-0.25rem\",display:props.titleName?\"\":\"none\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-FormGroup-60"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"flex-end\"}"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-FormGroup-61"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"flex-end\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "FormField",
      "parent": 60,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-FormField-62"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "FormField",
      "parent": 60,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-FormField-63"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "FormField",
      "parent": 60,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-FormField-64"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "FormField",
      "parent": 60,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-FormField-65"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormField",
      "parent": 61,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-FormField-66"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormField",
      "parent": 61,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-FormField-67"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "FormField",
      "parent": 61,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-FormField-68"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "label",
      "parent": 62,
      "props": {
        "children": {
          "type": "value",
          "value": "BookingID",
          "valueEN": "BookingID"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-label-70"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "label",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ - นามสกุลผู้รับบริการ"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-label-71"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "label",
      "parent": 64,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่นัดหมาย",
          "valueEN": "Appointment date"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-label-72"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "label",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ให้บริการ",
          "valueEN": "Service provider"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-label-74"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "label",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะนัดหมาย",
          "valueEN": "Appointment status"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-label-75"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "label",
      "parent": 68,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะรับบริการ",
          "valueEN": "Service status"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-label-76"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 80,
      "name": "FormField",
      "parent": 60,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-FormField-80"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "FormField",
      "parent": 60,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-FormField-81"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "label",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-label-82"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 81,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-div-83"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 84,
      "name": "DateTextBox",
      "parent": 64,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-DateTextBox-84"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate(\"startDate\")"
        },
        "value": {
          "type": "code",
          "value": "props.appointmentList?.filterAppointmentList?.startDate"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 85,
      "name": "DateTextBox",
      "parent": 80,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-DateTextBox-85"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate(\"endDate\")"
        },
        "value": {
          "type": "code",
          "value": "props.appointmentList?.filterAppointmentList?.endDate"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "label",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-label-86"
        },
        "style": {
          "type": "code",
          "value": "{paddingBottom: \"10px\"}"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "Dropdown",
      "parent": 67,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-Dropdown-88"
        },
        "name": {
          "type": "value",
          "value": "appointmentStatus"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.appointmentStatusOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.appointmentList?.filterAppointmentList?.appointmentStatus"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "Dropdown",
      "parent": 68,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-Dropdown-89"
        },
        "name": {
          "type": "value",
          "value": "orderStatus"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.orderStatusOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.appointmentList?.filterAppointmentList?.orderStatus"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 90,
      "name": "Input",
      "parent": 62,
      "props": {
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-Input-90"
        },
        "name": {
          "type": "value",
          "value": "id"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "placeholder": {
          "type": "value",
          "value": "ค้นหาด้วยหมายเลขการจอง"
        },
        "value": {
          "type": "code",
          "value": "props.appointmentList?.filterAppointmentList?.id"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 92,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-FormGroup-92"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 93,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-FormField-93"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchBoxPatient"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-div-95"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 93,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonAppointmentFinish"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-div-96"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchBoxDoctor"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentListMEHUX-div-97"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "FormField",
      "parent": 61,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "div",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", marginBottom: \"10px\"}"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "Checkbox",
      "parent": 100,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.appointmentList?.filterAppointmentList?.noDivisionServiceBlock"
        },
        "label": {
          "type": "value",
          "value": "แสดงนัดหมายที่ถูกเลื่อนแบบไม่ระบุวัน"
        },
        "name": {
          "type": "value",
          "value": "noDivisionServiceBlock"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "label",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 100,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 85,
  "isMounted": false,
  "memo": false,
  "name": "CardAppointmentListMEHUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 80
}

*********************************************************************************** */
